<script lang="ts" setup>
import { StyleValue } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    customStyle?: StyleValue;
  }>(),
  {
    customStyle: undefined,
  }
);

const emits = defineEmits<{
  (e: 'scroll');
}>();

const customCardStyle = props.customStyle ?? {};
</script>

<template>
  <div :style="customCardStyle" class="simple-card" @scroll="emits('scroll')">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.simple-card {
  line-height: 20px;
  font-size: $fontSizeS;
  background-color: $semanticWhite;
}
</style>
